import React, { useState, useEffect } from "react";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Cookies from "js-cookie";

// Add cyberpunk animations
const cyberpunkStyles = `
  @keyframes scan {
    0% { left: -100%; }
    100% { left: 100%; }
  }
  @keyframes pulse {
    0%, 100% { opacity: 0.5; }
    50% { opacity: 1; }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = cyberpunkStyles;
  document.head.appendChild(styleSheet);
}

const imageCasino = [
  {
    url: "/assets/fastspin.png",
    link: "/FASHPIN",
    name: "FS SLOT",
  },
  {
    url: "/assets/bng.png",
    link: "/BNG",
    name: "BNG SLOT",
  },
  {
    url: "/assets/pg.png",
    link: "/PG",
    name: "PG SLOT",
  },
  {
    url: "/assets/cq9.png",
    link: "/CQ9",
    name: "CQ9 SLOT",
  },
  {
    url: "/assets/evo.png",
    link: "/EVOPLAY",
    name: "EVO SLOT",
  },
  {
    url: "/assets/fc.png",
    link: "/FC",
    name: "FC SLOT",
  },
  {
    url: "/assets/jdb.png",
    link: "/JDB",
    name: "JDB SLOT",
  },
  {
    url: "/assets/jili.png",
    link: "/JILI",
    name: "JILI SLOT",
  },
  {
    url: "/assets/pragmatic-play.png",
    link: "/PP",
    name: "PP SLOT",
  },
  {
    url: "/assets/spadegaming.png",
    link: "/SPADEGAMING",
    name: "SPADE SLOT",
  },
  {
    url: "/assets/spribe.png",
    link: "/SPRIBE",
    name: "SPRIBE SLOT",
  },
  {
    url: "/assets/va.png",
    link: "/VA",
    name: "VA SLOT",
  },
];


const HomeNH = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<any>(null);
  const [centerHallIndex, setCenterHallIndex] = useState(2);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isAnalysisStarting, setIsAnalysisStarting] = useState(false);
  const navigate = useNavigate();

  // Add rainbow animation CSS
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes rainbow {
        0% { color: #ff0000; } /* Red */
        16% { color: #ff8000; } /* Orange */
        33% { color: #ffff00; } /* Yellow */
        50% { color: #00ff00; } /* Green */
        66% { color: #0080ff; } /* Blue */
        83% { color: #8000ff; } /* Purple */
        100% { color: #ff0080; } /* Pink */
      }
    `;
    document.head.appendChild(style);
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  const handleClick = (e: string) => {
    // Lưu thông tin sảnh vào localStorage
    const hallInfo = imageCasino.find(casino => casino.link === e);
    if (hallInfo) {
      localStorage.setItem('selected_hall_info', JSON.stringify({
        name: hallInfo.name,
        avatar: hallInfo.url.startsWith('/') ? hallInfo.url : `/${hallInfo.url}`
      }));
      console.log('Saved hall info:', hallInfo);
    }
    navigate(`/NH/slot${e}`);
  };

  const updateUserCoins = (coins: number) => {
    setUserInfo((prev: any) => {
      const next = { ...(prev || {}), coins };
      localStorage.setItem("user_info", JSON.stringify(next));
      return next;
    });
  };

  const runAnalysisProgress = () =>
    new Promise<void>((resolve) => {
      let progress = 0;
      let intervalId: ReturnType<typeof setInterval>;

      Swal.fire({
        html: `
          <div style="
            width: min(420px, 86vw);
            padding: 26px 24px 24px;
            color: #fff;
            font-family: Roboto, Arial, sans-serif;
            text-align: center;
          ">
            <div style="
              font-size: 26px;
              font-weight: 900;
              line-height: 1;
              background: linear-gradient(90deg, #00fbff, #ff00ff);
              -webkit-background-clip: text;
              color: transparent;
              filter: drop-shadow(0 0 12px rgba(0, 238, 255, 0.65));
              margin-bottom: 18px;
            ">AI ANALYSIS</div>
            <div id="home-nh-analysis-text-1" style="font-size: 15px; font-weight: 800; color: #00fbff; margin-bottom: 8px;">
              Đang phân tích dữ liệu sảnh...
            </div>
            <div id="home-nh-analysis-text-2" style="font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.82); margin-bottom: 18px;">
              Đang khởi tạo thuật toán AI
            </div>
            <div style="
              width: 100%;
              height: 14px;
              border-radius: 999px;
              overflow: hidden;
              background: rgba(0, 71, 171, 0.72);
              box-shadow: inset 0 0 8px rgba(0,0,0,0.5), 0 0 12px rgba(0,238,255,0.35);
            ">
              <div id="home-nh-analysis-progress" style="
                width: 0%;
                height: 100%;
                border-radius: inherit;
                background: linear-gradient(90deg, #00fbff 0%, #ff00ff 100%);
                box-shadow: 0 0 14px rgba(255,0,255,0.75);
                transition: width 120ms linear;
              "></div>
            </div>
            <div id="home-nh-analysis-percent" style="
              margin-top: 12px;
              font-size: 22px;
              font-weight: 900;
              color: #fff;
              text-shadow: 0 0 10px rgba(0, 238, 255, 0.7);
            ">0%</div>
          </div>
        `,
        background: "rgba(0, 8, 35, 0.92)",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: "custom-swal",
        },
        didOpen: () => {
          intervalId = setInterval(() => {
            progress = Math.min(progress + 2, 100);
            const progressEl = document.getElementById("home-nh-analysis-progress");
            const percentEl = document.getElementById("home-nh-analysis-percent");
            const text1El = document.getElementById("home-nh-analysis-text-1");
            const text2El = document.getElementById("home-nh-analysis-text-2");

            if (progressEl) progressEl.style.width = `${progress}%`;
            if (percentEl) percentEl.textContent = `${progress}%`;
            if (text1El && progress >= 45) text1El.textContent = "Đang tối ưu dữ liệu thắng...";
            if (text2El && progress >= 70) text2El.textContent = "Đang đồng bộ kết quả sảnh";

            if (progress >= 100) {
              clearInterval(intervalId);
              setTimeout(() => {
                Swal.close();
                resolve();
              }, 250);
            }
          }, 100);
        },
        willClose: () => {
          if (intervalId) clearInterval(intervalId);
        },
      });
    });

  const handleStartAnalysis = async () => {
    const currentCoins = Number(userInfo?.coins ?? 0);

    if (currentCoins < 1) {
      Swal.fire({
        icon: "warning",
        title: "Không đủ xu",
        text: "Bạn cần ít nhất 1 xu để bắt đầu phân tích.",
        confirmButtonText: "Đã hiểu",
      });
      return;
    }

    try {
      setIsAnalysisStarting(true);
      const token = Cookies.get("access_token");

      if (token) {
        const response = await axios.post(
          `${process.env.REACT_APP_URL_API}/users/subtract-coins-for-action`,
          { amount: 1, action: "START_ANALYSIS" },
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
        );
        updateUserCoins(Number(response.data?.coins ?? currentCoins - 1));
      } else {
        updateUserCoins(currentCoins - 1);
      }

      await runAnalysisProgress();
      handleClick(imageCasino[centerHallIndex].link);
    } catch {
      Swal.fire({
        icon: "error",
        title: "Không thể trừ xu",
        text: "Vui lòng thử lại sau.",
        confirmButtonText: "Đã hiểu",
      });
    } finally {
      setIsAnalysisStarting(false);
    }
  };

  useEffect(() => {
    // set initial
    const check = () => setIsMobile(window.innerWidth <= 430);
    check();
    window.addEventListener("resize", check);
    // load user info for profile area
    try {
      const u = localStorage.getItem("user_info");
      if (u) setUserInfo(JSON.parse(u));
    } catch (err) {
      setUserInfo(null);
    }
    return () => window.removeEventListener("resize", check);
  }, []);

  // Loading frame for mobile only
  useEffect(() => {
    if (isMobile) {
      Swal.fire({
        html: `
          <div style="
            background: 
              radial-gradient(circle at 20% 20%, rgba(138, 43, 226, 0.2) 0%, transparent 60%),
              radial-gradient(circle at 80% 80%, rgba(0, 191, 255, 0.15) 0%, transparent 60%),
              radial-gradient(circle at 50% 50%, rgba(255, 0, 150, 0.1) 0%, transparent 70%),
              linear-gradient(135deg, 
                rgba(10, 10, 25, 0.98) 0%, 
                rgba(20, 20, 40, 0.95) 25%,
                rgba(15, 15, 35, 0.98) 50%,
                rgba(25, 25, 45, 0.95) 75%,
                rgba(10, 10, 25, 0.98) 100%);
            border: 2px solid transparent;
            border-image: linear-gradient(45deg, #8a2be2, #00bfff, #ff0096, #8a2be2) 1;
            border-radius: 20px;
            padding: 40px;
            text-align: center;
            color: white;
            max-width: 350px;
            width: 90%;
            box-shadow: 
              0 0 50px rgba(138, 43, 226, 0.6),
              0 0 100px rgba(0, 191, 255, 0.3),
              0 0 150px rgba(255, 0, 150, 0.2),
              0 20px 60px rgba(0, 0, 0, 0.7),
              inset 0 0 40px rgba(138, 43, 226, 0.15),
              inset 0 0 80px rgba(0, 191, 255, 0.1);
            position: relative;
            font-family: 'Courier New', monospace;
          ">
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-bottom: 30px;
              animation: textGlow 2s ease-in-out infinite;
            ">
              <div style="
                width: 80px;
                height: 80px;
                background: linear-gradient(135deg, #8a2be2, #00bfff);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;
                font-size: 40px;
                color: #000;
                font-weight: bold;
                box-shadow: 
                  0 0 20px rgba(138, 43, 226, 0.6),
                  0 0 40px rgba(0, 191, 255, 0.3);
                animation: iconPulse 1.5s ease-in-out infinite;
                border: 2px solid rgba(255, 255, 255, 0.3);
              ">⚡</div>
              <h2 style="
                margin: 0; 
                color: #8a2be2; 
                font-size: 20px; 
                font-weight: 900;
                text-shadow: 
                  0 0 15px rgba(138, 43, 226, 0.8),
                  0 0 25px rgba(138, 43, 226, 0.5);
                letter-spacing: 2px;
                text-transform: uppercase;
                text-align: center;
                line-height: 1.2;
              ">INITIALIZING HACK TOOL...</h2>
            </div>
            
            <div style="
              margin-bottom: 25px; 
              font-size: 14px;
              display: flex;
              flex-direction: column;
              gap: 8px;
            ">
              <div style="
                padding: 8px 16px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 6px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                animation: progressGlow 1.5s ease-in-out infinite;
                text-align: center;
              ">
                <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải dữ liệu sảnh game...</span>
              </div>
              <div data-progress="2" style="
                padding: 8px 16px;
                background: rgba(255, 255, 255, 0.05);
                border-radius: 6px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                animation: progressGlow 1.5s ease-in-out infinite 0.5s;
                text-align: center;
              ">
                <span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Đang tải danh sách game...</span>
              </div>
            </div>
            
            <div style="
              width: 100%;
              height: 16px;
              background: rgba(255, 255, 255, 0.1);
              border-radius: 8px;
              overflow: hidden;
              margin-bottom: 15px;
              position: relative;
            ">
              <div id="progress-fill" style="
                width: 0%;
                height: 100%;
                background: linear-gradient(90deg, #8a2be2, #00bfff, #ff0096, #8a2be2);
                border-radius: 8px;
                transition: width 0.3s ease;
                box-shadow: 0 0 10px rgba(138, 43, 226, 0.5);
              "></div>
              <div id="progress-text" style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 12px;
                font-weight: bold;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
              ">0%</div>
            </div>
            
            <div style="
              font-size: 14px; 
              color: #00bfff;
              text-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
              letter-spacing: 1px;
            ">
              » HACK TOOL READY «
            </div>
          </div>
          
          <style>
            .loading-frame-popup {
              z-index: 99999 !important;
            }
            @keyframes textGlow {
              0%, 100% { text-shadow: 0 0 10px rgba(138, 43, 226, 0.5); }
              50% { text-shadow: 0 0 20px rgba(138, 43, 226, 0.8); }
            }
            @keyframes iconPulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.1); }
            }
            @keyframes progressGlow {
              0%, 100% { 
                background: rgba(255, 255, 255, 0.05);
                border-color: rgba(255, 255, 255, 0.1);
              }
              50% { 
                background: rgba(138, 43, 226, 0.1);
                border-color: rgba(138, 43, 226, 0.3);
              }
            }
            @keyframes progressBar {
              0% { transform: translateX(-100%); }
              100% { transform: translateX(100%); }
            }
          </style>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: {
          popup: 'loading-frame-popup'
        },
        backdrop: `
          rgba(0, 0, 0, 0.7)
          url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%238a2be2' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
          center/15px
        `
      });

      // Progress bar animation
      let progress = 0;
      const progressInterval = setInterval(() => {
        progress += 3.34; // 100% in ~3 seconds (update every 100ms)
        if (progress > 100) progress = 100;
        
        const progressFill = document.getElementById('progress-fill');
        const progressText = document.getElementById('progress-text');
        
        if (progressFill && progressText) {
          progressFill.style.width = progress + '%';
          progressText.textContent = Math.round(progress) + '%';
        }
        
        // Show "Tải dữ liệu thành công!" when progress reaches 100%
        if (progress >= 100) {
          const lastMessage = document.querySelector('[data-progress="2"]');
          if (lastMessage) {
            lastMessage.innerHTML = '<span style="color: rgba(255, 255, 255, 0.9); font-weight: 500;">Tải dữ liệu thành công!</span>';
          }
          clearInterval(progressInterval);
        }
      }, 100);

      // Close loading after 3 seconds
      setTimeout(() => {
        clearInterval(progressInterval);
        Swal.close();
      }, 3000);
    }
  }, [isMobile]);

  const formatCoins = (coins?: number) => Number(coins ?? 9999999).toLocaleString("en-US");
  const displayName = userInfo?.userName || userInfo?.username || "Xiaofeng";
  const carouselOffsets = [-2, -1, 0, 1, 2];
  const carouselItems = carouselOffsets.map((offset) => {
    const index = (centerHallIndex + offset + imageCasino.length) % imageCasino.length;
    return imageCasino[index];
  });
  const displayedHalls = isMobile ? imageCasino : carouselItems;
  const goPrevHall = () => {
    setCenterHallIndex((prev) => (prev - 1 + imageCasino.length) % imageCasino.length);
  };
  const goNextHall = () => {
    setCenterHallIndex((prev) => (prev + 1) % imageCasino.length);
  };

  return (
    <div
      className="home-nh-page"
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
        color: "#fff",
        fontFamily: '"Roboto", "Arial", sans-serif',
      }}
    >
      <style>
        {`
          .home-nh-topbar {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 24px 30px 0;
          }

          .home-nh-brand {
            width: 248px;
            max-width: 34vw;
            object-fit: contain;
            filter: drop-shadow(0 0 10px rgba(0, 238, 255, 0.35));
          }

          .home-nh-user-panel {
            width: 300px;
            max-width: 34vw;
          }

          .home-nh-user-row {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .home-nh-pill {
            height: 42px;
            border-radius: 10px;
            border: 1px solid rgba(0, 238, 255, 0.35);
            background: rgba(1, 16, 52, 0.72);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.35), inset 0 0 18px rgba(0, 119, 255, 0.18);
            display: flex;
            align-items: center;
            color: #fff;
            font-weight: 900;
          }

          .home-nh-user-pill {
            flex: 1;
            min-width: 0;
            padding: 0 10px;
            gap: 8px;
            cursor: pointer;
            user-select: none;
          }

          .home-nh-coin-pill {
            min-width: 134px;
            padding: 0 12px;
            gap: 8px;
            color: #ffd747;
          }

          .home-nh-vip {
            margin-left: auto;
            padding: 3px 8px;
            border-radius: 5px;
            background: linear-gradient(180deg, #ff5a47, #a90e18);
            color: #fff;
            font-size: 10px;
            line-height: 1;
          }

          .home-nh-menu {
            margin-top: 8px;
            margin-left: 2px;
            width: 142px;
            padding: 8px 12px;
            border-radius: 8px;
            border: 1px solid rgba(0, 238, 255, 0.34);
            background: rgba(1, 16, 52, 0.68);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.25);
            text-align: center;
            font-weight: 700;
            line-height: 1.35;
          }

          .home-nh-logout {
            color: #ffff00;
            cursor: pointer;
          }

          .home-nh-hero {
            position: relative;
            z-index: 1;
            margin-top: 22px;
            text-align: center;
          }

          .home-nh-title-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 286px;
            padding: 14px 34px 16px;
            border-radius: 999px;
            background: linear-gradient(180deg, rgba(14, 74, 177, 0.74), rgba(23, 5, 105, 0.7));
            border: 1px solid rgba(0, 238, 255, 0.28);
            box-shadow: 0 0 22px rgba(0, 119, 255, 0.6), inset 0 0 20px rgba(0, 238, 255, 0.18);
            overflow: visible;
          }

          .home-nh-title-text {
            font-size: 42px;
            font-weight: 900;
            line-height: 1.22;
            letter-spacing: 0.02em;
            background: linear-gradient(90deg, #00fbff 0%, #ff00ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 0 16px rgba(0, 238, 255, 0.7));
            display: inline-block;
            padding-top: 0.08em;
          }

          .home-nh-subtitle {
            margin-top: 22px;
            font-size: 28px;
            line-height: 1.2;
            color: rgba(255, 255, 255, 0.92);
            text-shadow: 0 0 12px rgba(0, 119, 255, 0.45);
          }

          .home-nh-carousel {
            position: relative;
            z-index: 1;
            height: 430px;
            margin: 70px auto 0;
            max-width: 1280px;
            perspective: 900px;
            perspective-origin: center center;
            transform-style: preserve-3d;
          }

          .home-nh-card {
            position: absolute;
            top: 0;
            left: 50%;
            width: 300px;
            height: 348px;
            border-radius: 26px;
            border: 4px solid rgba(0, 123, 255, 0.9);
            background: linear-gradient(180deg, rgba(0, 21, 78, 0.95), rgba(0, 8, 48, 0.94));
            box-shadow: 0 0 26px rgba(0, 119, 255, 0.85), inset 0 0 32px rgba(0, 119, 255, 0.2);
            padding: 18px 18px 20px;
            cursor: pointer;
            transform-origin: center center;
            transform-style: preserve-3d;
            backface-visibility: hidden;
            will-change: transform;
            transition: transform 0.35s ease, filter 0.25s ease;
          }

          .home-nh-card:hover {
            filter: brightness(1.1);
          }

          .home-nh-card-logo {
            height: 154px;
            border-radius: 16px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 14px;
            overflow: hidden;
          }

          .home-nh-card-logo img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .home-nh-card-name {
            margin-top: 16px;
            font-size: 36px;
            font-weight: 900;
            line-height: 1;
            color: #fff;
            text-align: center;
            text-shadow: 0 0 8px rgba(0, 119, 255, 0.6);
            white-space: nowrap;
          }

          .home-nh-stats {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            gap: 14px;
          }

          .home-nh-stat {
            min-width: 0;
            text-align: left;
          }

          .home-nh-stat:last-child {
            text-align: right;
          }

          .home-nh-stat-label {
            font-size: 14px;
            font-weight: 900;
            color: #fff;
            line-height: 1.1;
          }

          .home-nh-stat-value {
            margin-top: 6px;
            font-size: 34px;
            font-weight: 900;
            line-height: 1;
          }

          .home-nh-win {
            color: #00fbff;
            text-shadow: 0 0 10px rgba(0, 251, 255, 0.8);
          }

          .home-nh-players {
            color: #ff00ff;
            text-shadow: 0 0 10px rgba(255, 0, 255, 0.75);
          }

          .home-nh-card-pos-0 {
            transform: translateX(-620px) translateY(34px) rotateY(30deg) scale(0.82);
            z-index: 1;
            opacity: 0.86;
          }

          .home-nh-card-pos-1 {
            transform: translateX(-390px) translateY(16px) rotateY(24deg) scale(1);
            z-index: 3;
            opacity: 0.96;
          }

          .home-nh-card-pos-2 {
            transform: translateX(-50%) translateY(0) rotateY(0deg) scale(1.22);
            z-index: 5;
          }

          .home-nh-card-pos-3 {
            transform: translateX(90px) translateY(16px) rotateY(-24deg) scale(1);
            z-index: 3;
            opacity: 0.96;
          }

          .home-nh-card-pos-4 {
            transform: translateX(350px) translateY(34px) rotateY(-30deg) scale(0.82);
            z-index: 1;
            opacity: 0.86;
          }

          .home-nh-arrow {
            position: absolute;
            top: 165px;
            z-index: 10;
            width: 46px;
            height: 46px;
            border-radius: 50%;
            border: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: linear-gradient(180deg, #1685ff, #0649a5);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.72);
            font-size: 28px;
            font-weight: 900;
            cursor: pointer;
          }

          .home-nh-arrow-left {
            left: 8px;
          }

          .home-nh-arrow-right {
            right: 8px;
          }

          .home-nh-start-wrap {
            position: relative;
            z-index: 1;
            display: flex;
            justify-content: center;
            margin: 12px auto 0;
            padding-bottom: 42px;
          }

          .home-nh-start-btn {
            width: 450px;
            max-width: calc(100vw - 32px);
            min-height: 74px;
            border: 1px solid rgba(0, 238, 255, 0.72);
            border-radius: 999px;
            background:
              radial-gradient(circle at 84% 50%, rgba(176, 35, 255, 0.48) 0%, rgba(176, 35, 255, 0.2) 35%, transparent 64%),
              linear-gradient(90deg, rgba(0, 84, 255, 0.82) 0%, rgba(50, 26, 155, 0.82) 54%, rgba(147, 0, 255, 0.78) 100%);
            box-shadow:
              0 0 18px rgba(0, 238, 255, 0.72),
              0 0 30px rgba(147, 0, 255, 0.45),
              inset 0 0 22px rgba(255, 255, 255, 0.12);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 28px;
            cursor: pointer;
            transition: transform 0.2s ease, filter 0.2s ease, opacity 0.2s ease;
          }

          .home-nh-start-btn:hover {
            transform: translateY(-2px);
            filter: brightness(1.08);
          }

          .home-nh-start-btn:disabled {
            cursor: not-allowed;
            opacity: 0.65;
          }

          .home-nh-start-copy {
            display: flex;
            flex-direction: column;
            align-items: center;
            line-height: 1.1;
          }

          .home-nh-start-title {
            font-size: 26px;
            font-weight: 900;
            letter-spacing: 0.02em;
            text-transform: uppercase;
          }

          .home-nh-start-subtitle {
            margin-top: 6px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.78);
          }

          .home-nh-start-arrow {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.45);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 34px;
            line-height: 1;
            box-shadow: inset 0 0 14px rgba(255, 255, 255, 0.16);
          }

          @media (max-width: 768px) {
            .home-nh-topbar {
              padding: 14px 14px 0;
              align-items: center;
              flex-direction: column;
              gap: 12px;
            }

            .home-nh-brand {
              width: 210px;
              max-width: 82vw;
            }

            .home-nh-user-panel {
              width: min(340px, calc(100vw - 28px));
              max-width: none;
            }

            .home-nh-user-row {
              flex-direction: row;
              gap: 8px;
              align-items: center;
            }

            .home-nh-pill {
              height: 36px;
              font-size: 12px;
            }

            .home-nh-user-pill {
              flex: 1 1 auto;
            }

            .home-nh-coin-pill {
              min-width: 126px;
              flex: 0 0 auto;
            }

            .home-nh-menu {
              display: block;
              margin: 8px auto 0;
            }

            .home-nh-hero {
              margin-top: 24px;
              padding: 0 14px;
            }

            .home-nh-title-badge {
              min-width: 210px;
              padding: 12px 22px 14px;
            }

            .home-nh-title-text {
              font-size: 30px;
            }

            .home-nh-subtitle {
              margin-top: 14px;
              font-size: 16px;
            }

            .home-nh-carousel {
              height: auto;
              margin-top: 22px;
              padding: 0 18px 30px;
              display: grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 14px;
            }

            .home-nh-card {
              position: relative;
              left: auto;
              top: auto;
              width: 100%;
              height: auto;
              min-height: 224px;
              padding: 13px;
              transform: none !important;
              opacity: 1;
              border-radius: 22px;
            }

            .home-nh-card-logo {
              height: 92px;
            }

            .home-nh-card-name {
              font-size: 20px;
            }

            .home-nh-stat-value {
              font-size: 22px;
            }

            .home-nh-stat-label {
              font-size: 10px;
            }

            .home-nh-arrow {
              display: none;
            }

            .home-nh-start-wrap {
              margin-top: 4px;
              padding-bottom: 28px;
              padding-left: 14px;
              padding-right: 14px;
            }

            .home-nh-start-btn {
              min-height: 64px;
              gap: 18px;
            }

            .home-nh-start-title {
              font-size: 20px;
            }

            .home-nh-start-subtitle {
              font-size: 12px;
            }

            .home-nh-start-arrow {
              width: 38px;
              height: 38px;
              font-size: 28px;
            }
          }
        `}
      </style>
      {/* Video background */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
          backgroundSize: "contain",
          backgroundRepeat: "repeat",
          backgroundPosition: "top"
        }}
      >
        <source
          src={!isMobile ? "/assets/bg-pc.mp4" : "/assets/bg-mb.mp4"}
          type="video/mp4"
        />
      </video>

      <div className="home-nh-topbar">
        <img className="home-nh-brand" src="/assets/logo-header.png" alt="Velixia Slot" />

        <div className="home-nh-user-panel">
          <div className="home-nh-user-row">
            <div
              className="home-nh-pill home-nh-user-pill"
              role="button"
              tabIndex={0}
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setIsUserMenuOpen((prev) => !prev);
                }
              }}
            >
              <img src="/assets/icon-user.png" alt="" style={{ width: 28, height: 28 }} />
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{displayName}</span>
              <span className="home-nh-vip">VIP 10</span>
            </div>
            <div className="home-nh-pill home-nh-coin-pill">
              <span
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "linear-gradient(180deg, #ffd64b, #d28b00)",
                  color: "#8a4b00",
                  fontWeight: 900,
                }}
              >
                $
              </span>
              <span>{formatCoins(userInfo?.coins)}</span>
            </div>
          </div>

          {isUserMenuOpen && (
          <div className="home-nh-menu">
            <div className="home-nh-logout" onClick={() => setIsShowLogout(true)}>
              Đăng xuất
            </div>
          </div>
          )}
        </div>
      </div>

      <section className="home-nh-hero">
        <div className="home-nh-title-badge">
          <span className="home-nh-title-text">CHỌN SẢNH</span>
        </div>
        <div className="home-nh-subtitle">Chọn sảnh để bắt đầu phân tích</div>
      </section>

      <section className="home-nh-carousel" aria-label="Danh sách sảnh slot">
        <button
          type="button"
          className="home-nh-arrow home-nh-arrow-left"
          aria-label="Sảnh trước"
          onClick={goPrevHall}
        >
          ‹
        </button>
        <button
          type="button"
          className="home-nh-arrow home-nh-arrow-right"
          aria-label="Sảnh sau"
          onClick={goNextHall}
        >
          ›
        </button>

        {displayedHalls.map((item, index) => (
          <article
            key={item.link}
            className={`home-nh-card home-nh-card-pos-${index}`}
            onClick={() => handleClick(item.link)}
          >
            <div className="home-nh-card-logo">
              <img src={item.url} alt={item.name} onError={(ev) => (ev.currentTarget.src = "/assets/logo.png")} />
            </div>
            <div className="home-nh-card-name">{item.name}</div>
            <div className="home-nh-stats">
              <div className="home-nh-stat">
                <div className="home-nh-stat-label">TỶ LỆ THẮNG</div>
                <div className="home-nh-stat-value home-nh-win">87.6%</div>
              </div>
              <div className="home-nh-stat">
                <div className="home-nh-stat-label">NGƯỜI CHƠI</div>
                <div className="home-nh-stat-value home-nh-players">2,124</div>
              </div>
            </div>
          </article>
        ))}
      </section>

      <div className="home-nh-start-wrap">
        <button
          type="button"
          className="home-nh-start-btn"
          onClick={handleStartAnalysis}
          disabled={isAnalysisStarting}
        >
          <span className="home-nh-start-copy">
            <span className="home-nh-start-title">
              {isAnalysisStarting ? "PROCESSING..." : "START ANALYSIS"}
            </span>
            <span className="home-nh-start-subtitle">Bắt đầu phân tích với AI</span>
          </span>
          <span className="home-nh-start-arrow">→</span>
        </button>
      </div>

      {/* Mobile cũ đã đơn giản hóa thành grid trên, không cần layout riêng nữa */}
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomeNH;
